import { render, staticRenderFns } from "./GetGood.vue?vue&type=template&id=e3c555a6&scoped=true&"
import script from "./GetGood.vue?vue&type=script&lang=js&"
export * from "./GetGood.vue?vue&type=script&lang=js&"
import style0 from "./GetGood.vue?vue&type=style&index=0&id=e3c555a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c555a6",
  null
  
)

export default component.exports